import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  zh: {
    message: {
      title: '泳池换装',
      switchLanguage: '切换语言',
      music: '背景音乐',
      share: '分享',
      pattern: '花色选择',
      category: '系列选择',
      backToCategories: '返回类型',
      noPatterns: '暂无花色',
      fetchPatternsError: '获取花色列表失败',
      loadingAd: '池内防水，原来可以如此简单',
      loadingAdEn: 'Waterproofing, So Easy',
      loading: '加载中...',
      copySuccess: '链接已复制，可发送给好友',
      copyFailed: '复制失败，请手动复制链接',
      musicLoading: '背景音乐正在加载中，请稍候...',
      loadMore: '加载更多',
      viewMode: {
        full: '完整场景',
        empty: '无水场景',
        detail: '细节展示'
      },
      button: {
        share: '分享',
        play: '播放',
        pause: '暂停',
        menu: '菜单',
        switchPattern: '切换花色',
        switchCategory: '选择类型',
        back: '返回'
      },
      tip: {
        choosePattern: '请先选择类型和花色',
        landscape: '请将手机横屏使用',
        landscapeSub: '为了获得最佳体验，请横屏查看',
        wechat: '请在菜单中选择在浏览器中打开，以完成',
        safari: '在Safari中打开',
        browser: '在浏览器中打开'
      }
    }
  },
  en: {
    message: {
      title: 'Pool Design',
      switchLanguage: 'Switch Language',
      music: 'Background Music',
      share: 'Share',
      pattern: 'Pattern Selection',
      category: 'Series Selection',
      backToCategories: 'Back to Category',
      noPatterns: 'No patterns',
      fetchPatternsError: 'Failed to fetch patterns',
      loadingAd: 'Waterproofing, So Easy',
      loadingAdEn: 'Waterproofing, So Easy',
      loading: 'Loading...',
      copySuccess: 'Link copied, you can share it now',
      copyFailed: 'Copy failed, please copy manually',
      musicLoading: 'Background music is loading, please wait...',
      loadMore: 'Load More',
      viewMode: {
        full: 'Full Scene',
        empty: 'No Water',
        detail: 'Detail'
      },
      button: {
        share: 'Share',
        play: 'Play',
        pause: 'Pause',
        menu: 'Menu',
        switchPattern: 'Pattern',
        switchCategory: 'Category',
        back: 'Back'
      },
      tip: {
        choosePattern: 'Please select a category and pattern first',
        landscape: 'Please rotate your device to landscape mode',
        landscapeSub: 'For the best viewing experience, please use landscape orientation',
        wechat: 'Please open in browser',
        safari: 'Open in Safari',
        browser: 'Open in Browser'
      }
    }
  }
}

const i18n = new VueI18n({
  locale: 'zh',
  messages
})

export default i18n 